import React from 'react';
import { MessageSquare } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Users",
    title: "Create Your Community",
    description: "A forum for support and sharing, tailored to your image"
  },
  {
    iconName: "MessageSquare",
    title: "Themed Forums",
    description: "According to your project"
  },
  {
    iconName: "Award",
    title: "Points System",
    description: "Rewards and badges"
  },
  {
    iconName: "Search",
    title: "Advanced Search",
    description: "Quickly find articles"
  },
  {
    iconName: "Bell",
    title: "Notifications",
    description: "Stay informed in real-time"
  },
  {
    iconName: "Shield",
    title: "Moderation",
    description: "A healthy and secure environment"
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or certificate of enrollment"
  },
  {
    title: "Order Your Forum",
    description: "Request the creation of your personalized forum and enjoy it!"
  }
];

const ResourcesPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.europeanstudent.org/store/forum';
  };
  return (
    <div>
      <ServiceHeader
        title="Student Forum"
        description="A space for exchange and support for the entire student community."
        icon={<MessageSquare className="w-8 h-8 text-white" />}
        color={colors.accent1}
        imageUrl="https://i.imgur.com/haeG8WV.jpeg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent1}
            />
          ))}
        </div>

        {/* Forum Categories */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">For Which Project?</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Studies</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Orientation and Pathways</li>
                  <li>• Methodology</li>
                  <li>• Exams and Competitions</li>
                  <li>• Internships and Apprenticeships</li>
                  <li>• International</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Student Life</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Housing</li>
                  <li>• Good Deals</li>
                  <li>• Health and Well-being</li>
                  <li>• Associations</li>
                  <li>• Events</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="pt-11">
          <ServiceSteps
                title="How to Benefit"
                steps={steps}
                color={colors.accent1}
                ctaText="Order my forum"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;